export default __webpack_public_path__ + "static/media/chain.c5b7ff58.svg";